import * as types from './action_types'
import { GetRequest, GetRequestCachedV3, PostRequest, PostRequestCachedV3, PostRequestV2 } from '../../components/common/api'
import { API_CACHE_DURATION, urls } from '../../components/common/constants'
import { updateLoader, updateAlertError, UpdateCheckingReport } from '../common/common_action'
import { CONFIGURE_MASTER_BUS_NUMBER, NO_TRIPS_IN_SELECTED } from '../../components/common/error_strings'
import { parseCustomDate, randomString } from '../../components/common/helper'
import { SAFAR_EXPRESS } from '../../helper/companyIdhardcode'

export const updateDispatchItemList = (data) => {
  return { type: types.DISPATCH_ITEM_LIST, data }
}
export const insertDispatchResult = (data) => {
  return { type: types.INSERT_DISPATCH_ITEM, data }
}
export const updateCrossingCities = (data) => {
  return { type: types.CROSSING_CITY, data }
}
export const updateDefaultCrossing = (data) => ({ type: types.DEFAULT_CROSSING_CITY_BRANCH, data })

export const updateCrossingBranches = (data) => {
  return { type: types.CROSSING_BRANCH, data }
}
export const updateDestinationBranchDispatch = (data) => {
  return { type: types.DESTINATION_BRANCH, data }
}
export const updateDispatchedLuggage = (data) => {
  return { type: types.DISPATCHED_LUGGAGE, data }
}
export const updateEditDispatch = (data) => {
  return { type: types.EDIT_DISPATCH, data }
}
export const updateUpdateDispatch = (data) => {
  return { type: types.UPDATE_DISPATCH, data }
}
export const updateCancelDIspatch = (data) => {
  return { type: types.CANCEL_DISPATCH, data }
}
export const updateDispatchMemo = (data) => {
  return { type: types.DISPATCH_MEMO, data }
}
export const updatebusAndCargoTripMaping = (data) => {
  return { type: types.GET_BUS_AND_CARGO_TRIP_MAPING, data }
}
export const updateBusMasterType = (data) => {
  return { type: types.GET_BUS_MASTER_TYPE, data }
}
export const dispatchGlobalStateReset = () => {
  return { type: types.DISPATCH_GLOBAL_STATE_RESET }
}
export const updateDestCityWithCrossingBranch = (data) => {
  return { type: types.DESTCITY_WITH_CROSSING_BRANCH, data }
}
export const getupdateDispatchItemList = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.GetMultipleBranchLuggageToDispatch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        if (res.Data.length) {
          if(data?.intCompanyID === SAFAR_EXPRESS){
            dispatch(updateDispatchItemList(res.Data.sort((a, b) => parseCustomDate(a.BookingDate) - parseCustomDate(b.BookingDate))))
          }else{
            dispatch(updateDispatchItemList(res.Data.sort((a, b) => parseCustomDate(b.BookingDate) - parseCustomDate(a.BookingDate))))
          }
        } else {
          dispatch(updateDispatchItemList(res.Data))
        }
      } else {
        dispatch(updateDispatchItemList([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const insertDispatchData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.insertDispatch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(insertDispatchResult(res))
      } else {
        dispatch(insertDispatchResult([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const insertDispatchDataPromise = (data) => {
  return new Promise((resolve, reject) => {
    PostRequest(urls.insertDispatch, data)
      .then((res) => {
        if (res.status === 'Success') {
          resolve(res);
        } else {
          reject(res.ErrMessage || "Error inserting dispatch data");
        }
      })
      .catch((err) => reject(err));
  });
};

export const insertReceiveDataPromise = (data) => {
  return new Promise((resolve, reject) => {
    PostRequest(urls.getReceiveReceive, data)
      .then((res) => {
        if (res.status === 'Success') {
          resolve(res);
        } else {
          reject(res.ErrMessage || "Error inserting receive data");
        }
      })
      .catch((err) => reject(err));
  });
};
export const insertReceiveAllPromise = (data) => {
  return new Promise((resolve, reject) => {
    PostRequest(urls.getReceiveInsertAllV2, data)
      .then((res) => {
        if (res.status === 'Success') {
          resolve(res);
        } else {
          reject(res.ErrMessage || "Error inserting receive data");
        }
      })
      .catch((err) => reject(err));
  });
};

export const insertDispatchAllV2Data = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.insertDispatchAllV2, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(insertDispatchResult(res))
      } else {
        dispatch(insertDispatchResult([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getCrossingCity = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.crossingCities, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCrossingCities(res.Data))
        dispatch(updateDefaultCrossing(res?.Data1?.[0]))
      } else {
        dispatch(updateCrossingCities([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getCrossingBranch = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.crossingBranches, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateCrossingBranches(res.Data))
      } else {
        dispatch(updateCrossingBranches([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getDestinationBranchDispatch = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.dispatchDestinationBranchList, data,true,API_CACHE_DURATION)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateDestinationBranchDispatch(res.Data))
      } else {
        dispatch(updateDestinationBranchDispatch([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getDispatchedLuggage = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getDispatchedLuggage, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateDispatchedLuggage(res.Data))
      } else {
        dispatch(updateDispatchedLuggage([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const editDispatchAction = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.editDispatch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateEditDispatch(res.Data.Table))
      } else {
        dispatch(updateEditDispatch([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const updateDispatch = (data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.updateDispatch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateUpdateDispatch(res))
        // dispatch(updateAlertError({ show: true, msg: 'Successfully Updated!', nextId: '', close: onClosePopup, success: true }))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage }))
        dispatch(updateUpdateDispatch([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const cancelDIspatch = (data, onClosePopup) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.cancelDIspatch, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAlertError({ show: true, msg: 'Cancelled Successfully', close: onClosePopup, success: true }))
        dispatch(updateCancelDIspatch(res.Data))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, close: onClosePopup }))
        dispatch(updateCancelDIspatch([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const checkinReport = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.checkinReport, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(UpdateCheckingReport(res))
      } else {
        dispatch(UpdateCheckingReport([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const dispatchMemo = (data,UseToPayAsCOD) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.dispatchMemo, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        let responseData = res.Data;
        if (UseToPayAsCOD === 1 && responseData?.Table?.length > 0) {
          responseData = {
            ...responseData,
            Table: responseData.Table.map((item) => {
              let newPaymentType = item.PaymentType;
              if (item.PaymentType === 'TOPAY') newPaymentType = 'COD';
              else if (item.PaymentType === 'TOPAY(MANUAL)') newPaymentType = 'COD(MANUAL)';
              else if (item.PaymentType === 'ToPayDDDV') newPaymentType = 'COD(DDDV)';
              return { ...item, PaymentType: newPaymentType };
            }),
          };
        }
        dispatch(updateDispatchMemo(responseData));
      } else {
        dispatch(updateDispatchMemo([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getFleetOpTripMaping =(data)=> (dispatch)=>{
  return new Promise((resolve, reject) => {
    PostRequest(urls.GetTripSheetDetails, data)
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const getbusAndCargoTripMaping = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  const { intMode: mode } = data
  GetRequest(urls.busAndCargoTripMaping, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === true) {
        if (mode === 0) {
          if (res.Data.Table.length) {
            dispatch(updateBusMasterType({ data: res?.Data?.Table?.[0]?.busmastertype, random: randomString(5) }))
          } else {
            dispatch(updateAlertError({ show: true, msg: CONFIGURE_MASTER_BUS_NUMBER, nextId: '' }))
            dispatch(updateBusMasterType(false))
          }
        } else {
          if (res.Data1.Table.length) {
            dispatch(updatebusAndCargoTripMaping(res.Data1.Table))
          } else {
            dispatch(updateAlertError({ show: true, msg: NO_TRIPS_IN_SELECTED, nextId: '' }))
            dispatch(updateBusMasterType(false))
          }
        }
      } else {
        dispatch(updatebusAndCargoTripMaping([]))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const GetDestCitiesWithCrossingBranch = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.GetDestCitiesWithCrossingBranch, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      const { Data, ErrMessage, status = '' } = res
      if (status === 'Success') {
        const { Table = [] } = Data
        const [corssingCityData = {}] = Table
        const ids = ['', 1, 2, 3, 4, 5]
        const cityList = ids.reduce(
          (result, id) => {
            const cityID = corssingCityData['CrossingCityID' + id]
            if (cityID && !result.set.has(cityID)) {
              result.set.add(cityID)
              result.list.push({
                CityID: cityID,
                CityName: corssingCityData['CrossinCityName' + id],
              })
            }
            return result
          },
          { list: [], set: new Set() }
        ).list
        const branchList = ids.reduce(
          (result, id) => {
            const branchID = corssingCityData['CrossingBranchID' + id]
            if (branchID && !result.set.has(branchID)) {
              result.set.add(branchID)
              result.list.push({
                CityID: corssingCityData['CrossingCityID' + id],
                BranchID: branchID,
                BranchName: corssingCityData['CrossingBranchName' + id],
              })
            }
            return result
          },
          { list: [], set: new Set() }
        ).list
        if (cityList.length) {
          dispatch(updateDestCityWithCrossingBranch({ crossingCities: cityList, crossingBranches: branchList }))
          dispatch(updateDefaultCrossing(cityList[0]))
        } else {
          dispatch(updateDestCityWithCrossingBranch({ crossingCities: [], crossingBranches: [] }))
        }
      } else {
        dispatch(updateDestCityWithCrossingBranch({ crossingCities: [], crossingBranches: [] }))
        dispatch(updateAlertError({ show: true, msg: ErrMessage, nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateDestCityWithCrossingBranch([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}